import { isCustomerTooOld, isCustomerTooYoung } from "../utils";

import { Option } from "@storeblocks/select";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { isDefined } from "Utils/functions";

export function lastThreeYearsAsOptions(defaultLabel: string): Option[] {
  const thisYear = new Date().getFullYear();
  const threeYearsAgo = thisYear - 3;
  const years = range(threeYearsAgo, thisYear)
    .map((year) => ({
      label: `${year}`,
      value: `${year}`,
    }))
    .reverse();
  return [{ label: defaultLabel, value: "" }, ...years];
}

function range(start: number, end: number): number[] {
  return [...Array(1 + end - start).keys()].map((n) => start + n);
}

export const zipCodeRegex = /^000[1-9]$|^00[1-9]\d$|^0[1-9]\d{2}$|^[1-9]\d{3}$/;

export function getYearlyDiscountValue(
  deductible: any,
  coverageFields: string[],
  coverages: CoveragePriceCalculation[],
): number | undefined {
  let yearlyDiscount = 0;

  coverages.forEach(([coverage, priceCalculationEntry]) => {
    if (coverageFields.includes(coverage)) {
      const deductiblePrice = priceCalculationEntry.prices.find(
        (price) => price.value === deductible,
      );

      if (!isDefined(deductiblePrice)) {
        return;
      }

      if (
        deductiblePrice.fullYearlyPricePrecise &&
        deductiblePrice.fullYearlyPricePrecise >
          deductiblePrice.yearlyPricePrecise
      ) {
        yearlyDiscount +=
          deductiblePrice.fullYearlyPricePrecise -
          deductiblePrice.yearlyPricePrecise;
      }
    }
  });

  return yearlyDiscount;
}

export const customerIsWithinAgeRange = (
  customerDateOfBirth: string | undefined,
  maxAge: number,
  minAge: number,
): boolean => {
  return (
    !isCustomerTooOld(maxAge, customerDateOfBirth) &&
    !isCustomerTooYoung(minAge, customerDateOfBirth)
  );
};
